function importAll (r) {
  r.keys().forEach(r);
}

importAll(require.context('./', false, /\.png$/));
importAll(require.context('./', false, /\.svg$/));
importAll(require.context('./no-image', true, /\.jpg$/));
